import { CheckOutlined, CopyOutlined } from '@ant-design/icons'
import { Button, ButtonProps, message } from 'antd'
import React, { ReactNode, useState } from 'react'

export const CopyToClipboardButton: React.FC<{
  value: string
  children?: ReactNode
  propsButton?: ButtonProps
}> = ({ value, children, propsButton = {} }) => {
  const [copied, setCopied] = useState(false)

  const copyToClipboard: React.MouseEventHandler<HTMLElement> = event => {
    event.stopPropagation()

    navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 2000) // Revert to clipboard icon after 2 seconds
      })
      .catch(() => {
        message.error('Failed to copy')
      })
  }

  return (
    <Button
      className={copied ? 'button-clicked' : ''}
      style={{
        padding: 0,
      }}
      size="small"
      type="text"
      icon={copied ? <CheckOutlined /> : <CopyOutlined />}
      onClick={copyToClipboard}
      {...propsButton}
    >
      {children}
    </Button>
  )
}
